// validation/section1.js

const isEmpty = (v) =>
  v === null || v === undefined || (typeof v === "string" && v.trim() === "");

const isPhoneValid12 = (v) => typeof v === "string" && v.length === 12;

const ensureArray = (maybeArrayOrObject) => {
  if (Array.isArray(maybeArrayOrObject)) return maybeArrayOrObject;
  if (maybeArrayOrObject && typeof maybeArrayOrObject === "object")
    return Object.values(maybeArrayOrObject);
  return [];
};

// src/frontend/.../Recruitment/validation/section1.js

export function validateSection1(data = {}) {
  const formData = {
    personalDetails: data.personalDetails || {},
    previousAddress: Array.isArray(data.previousAddress)
      ? data.previousAddress
      : data.previousAddress && typeof data.previousAddress === "object"
      ? Object.values(data.previousAddress)
      : [],
    nextOfKinDetails: data.nextOfKinDetails || {},
    applicationDetails: data.applicationDetails || {},
  };

  const formErrors = {};

  const requiredFields = {
    personalDetails: [
      "title",
      "surname",
      "forename",
      "dob",
      "useSameDeatilsPostAppointment",
      "mobileTelephone",
      "emailAddress",
      "currentAddress",
      "currentTown",
      "currentCounty",
      "currentPostcode",
      "movingInDate",
      "consentToDisclosureScotlandCheck",
      "nationalInsuranceNumber",
      "tempNationalInsuranceNumber",
      "nationalityAtBirth",
      "townOfBirth",
      "countryOfBirth",
      "mothersMaidenName",
    ],
    nextOfKinDetails: [
      "name",
      "address",
      "town",
      "county",
      "postcode",
      "relationship",
    ],
    applicationDetails: [
      "applyingToJoin",
      "tradingStyle",
      "businessAreas",
      "referredBusiness",
    ],
  };

  //  EXACT: applyingAs required
  const applyingAs = formData.applicationDetails.applyingAs || [];
  if (applyingAs?.length === 0) {
    formErrors["applicationDetails.applyingAs"] = "This field is required.";
  }

  //  EXACT: businessAreas required (length 0)
  const businessAreas = formData.applicationDetails.businessAreas || [];
  if (businessAreas.length === 0) {
    formErrors["applicationDetails.businessAreas"] =
      "This field is required. Please select at least one option.";
  }

  //  EXACT: ARBusinessAreas required ONLY when applyingAs === "Selling Principal" (string check)
  const arBusinessAreas = formData.applicationDetails.ARBusinessAreas || [];
  if (
    formData.applicationDetails.applyingAs &&
    formData.applicationDetails.applyingAs === "Selling Principal" &&
    arBusinessAreas.length === 0
  ) {
    formErrors["applicationDetails.ARBusinessAreas"] =
      "This field is required. Please select at least one option.";
  }

  //  EXACT: personalDetails.mobileTelephone length rule
  const mobilePhone = formData.personalDetails.mobileTelephone;
  if (
    !mobilePhone ||
    (typeof mobilePhone === "string" && mobilePhone.trim() === "")
  ) {
    formErrors["personalDetails.mobileTelephone"] =
      "This field is required. Please select an option.";
  }

  //  EXACT: nextOfKin email/telephone rule
  const { email, telephone } = formData.nextOfKinDetails;

  const missingEmail =
    !email || (typeof email === "string" && email.trim() === "");
  const missingPhone =
    !telephone || (typeof telephone === "string" && telephone.trim() === "");

  if (missingEmail && missingPhone) {
    formErrors["nextOfKinDetails.email"] = "This field is required.";
    formErrors["nextOfKinDetails.telephone"] = "This field is required.";
  }

  //  EXACT: required fields scan (same logic/messages)
  Object.entries(requiredFields).forEach(([section, fields]) => {
    fields.forEach((field) => {
      const value = formData?.[section]?.[field];

      if (field === "applyingAs" && (!value || value.length === 0)) {
        formErrors[`${section}.${field}`] =
          "This field is required. Please select at least one option.";
      } else if (
        value === null ||
        value === undefined ||
        (typeof value === "string" && value.trim() === "")
      ) {
        formErrors[`${section}.${field}`] = "This field is required";
      }
    });
  });

  //  EXACT: previous addresses required fields
  formData.previousAddress.forEach((address, index) => {
    const requiredAddressFields = [
      "address",
      "town",
      "county",
      "postcode",
      "from",
      "to",
    ];
    requiredAddressFields.forEach((field) => {
      const value = address?.[field];
      if (!value || (typeof value === "string" && value.trim() === "")) {
        formErrors[`previousAddress.${index}.${field}`] =
          "This field is required";
      }
    });
  });

  //  EXACT: referredBusinessDetails required if referredBusiness === true
  if (
    formData.applicationDetails.referredBusiness === true &&
    typeof formData.applicationDetails.referredBusinessDetails === "string" &&
    formData.applicationDetails.referredBusinessDetails.trim() === ""
  ) {
    formErrors["applicationDetails.referredBusinessDetails"] =
      "This field is required";
  }

  //  EXACT: post appointment validation when useSameDeatilsPostAppointment === false
  if (formData.personalDetails.useSameDeatilsPostAppointment === false) {
    const phone = formData.personalDetails.postAppointmentMobileTelephone;

    if (!phone || (typeof phone === "string" && phone.trim() === "")) {
      formErrors["personalDetails.postAppointmentMobileTelephone"] =
        "This field is required";
    }

    const email2 = formData.personalDetails.postAppointmentEmailAddress;
    if (
      email2 === null ||
      email2 === undefined ||
      (typeof email2 === "string" && email2.trim() === "")
    ) {
      formErrors["personalDetails.postAppointmentEmailAddress"] =
        "This field is required";
    }
  }

  return formErrors;
}
